import "./HelpButton.less";

import { GuxIcon, GuxTooltip } from "genesys-spark-components-react";
import strings from "./HelpButton.strings";
import { useStrings } from "features/i18n/useStrings";

export function HelpButton({ helpText = undefined }: { helpText?: string }) {
    const t = useStrings(strings);

    return helpText ? (
        <div className="help-text" data-testid="help-text-icon" tabIndex={0}>
            <GuxIcon
                icon-name="fa/circle-question-regular"
                screenreaderText={t.labels.helpText({ helpText })}
            />
            <GuxTooltip placement="bottom-end">
                <div
                    slot="content"
                    data-testid="help-text-scrollable"
                    className="help-text-scrollable"
                    aria-label={t.labels.scrollableHelpText}
                >
                    <span aria-hidden="true">{helpText}</span>
                </div>
            </GuxTooltip>
        </div>
    ) : null;
}
